<template lang="pug">
  div(class="autofill-data__wrapper")
    div(class="autofill-data__header")
      img(
        src="~/assets/images/pen.gif"
        alt="✏️"
        class="autofill-data__emoji"
      )
      div
        h2(
          class="bold"
          :class="[xsDevice ? 'title-24px' : 'title-32px']"
        ) {{ $t('Autofill data') }}
        p(:class="[xsDevice ? 'text-12px' : 'text-14px']")
          | {{ $t('Your personal data will be used only to fill in this document. Choose an authorization method') }}
    div(class="autofill-data__body")
      div(class="autofill-data__options")
        div(class="autofill-option")
          div(class="autofill-option__content")
            img(
              src="~/assets/images/diia.svg"
              alt="Дія"
              class="autofill-option__logo autofill-option__logo--diia"
            )
            h3(class="text-16px dark") {{ $t('Digital passport') }}
            p(class="text-12px")
              | {{ $t('Automatically fills document fields with your data in 30 seconds') }}
            ul(class="autofill-option__list")
              li(class="text-12px dark") ✔ {{ $t('Fullname (surname, first name, last name)') }}
              li(class="text-12px dark") ✔ {{ $t('Birth day') }}
          div(class="autofill-option__actions")
            v-btn(
              class="main-button color-dark"
              @click="onDia"
            )
              e-svg-icon(class="pr-2") diia-1
              span {{ $t('Signature') }}
        div(class="autofill-option")
          div(class="autofill-option__content")
            img(
              :src="require('~/assets/images/new-label.png')"
              alt="soon"
              class="autofill-option__new-label"
            )
            img(
              src="~/assets/images/bank-id.png"
              alt="bankID"
              class="autofill-option__logo autofill-option__logo--bank-id"
            )
            h3(class="text-16px dark") {{ $t('Bank assurance') }}
            p(class="text-12px")
              | {{ $t('Automatic document filling with verified data from your bank') }}
            ul(class="autofill-option__list")
              li(class="text-12px dark") ✔ {{ $t('Fullname (surname, first name, last name)') }}
              li(class="text-12px dark") ✔ {{ $t('Birth day') }}
          div(class="autofill-option__actions")
            v-btn(
              class="secondary-button"
              disabled
              @click="onBankId"
            ) {{ $t('Get data from bank') }}
</template>

<script>
import documentActions from '~/modules/documents/mixins/documentActions'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'MAutofillData',
  mixins: [documentActions, responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => {}
    },
    onSuccess: {
      type: Function,
      default: () => {}
    },
    field: {
      type: String,
      default: null
    }
  },
  methods: {
    onDia() {
      this.closeModal(true)
      this.openDiaDialog({
        handler: this.onSuccess,
        field: this.field
      })
    },
    onBankId() {
      this.$emit('onBankId')
    }
  }
}
</script>

<style lang="scss" scoped>
.autofill-data {
  &__header {
    padding: 12px;
    text-align: left;
    gap: 8px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    min-height: 200px;
    background: transparent;
    background: linear-gradient(91deg, #fff -29.58%, #f8e3f4 66.15%);

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 12px 32px;
      flex-direction: row;
      gap: 32px;
      align-items: center;
    }
  }
  &__emoji {
    width: 40px;
    height: 40px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      width: 80px;
      height: 80px;
      margin-bottom: 8px;
    }
  }
  &__body {
    padding: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      padding: 32px 40px 40px 40px;
    }
  }
  &__options {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      grid-template-columns: 1fr 1fr;
    }
  }
}

/* ===== card (option) ===== */
.autofill-option {
  padding: 16px;
  position: relative;

  border-radius: 16px;
  border: 1px solid #e3e3e3;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &__new-label {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: map-get($zIndexes, 'base');
  }

  &__logo {
    margin-bottom: 16px;

    &--diia {
      width: 32px;
      height: auto;
    }
    &--bank-id {
      width: 96px;
      height: auto;
    }
  }

  &__list {
    list-style: none;
    padding-left: 0;
    margin-bottom: 24px;

    li {
      margin-bottom: 4px;
    }
  }

  .v-btn {
    width: 100%;
  }
}
</style>
